module.exports = __webpack_public_path__ + "static/media/Implant.4670d936.jpeg";